import { render } from "./HeroImage.vue?vue&type=template&id=3dd953ec&scoped=true"
import script from "./HeroImage.vue?vue&type=script&lang=js"
export * from "./HeroImage.vue?vue&type=script&lang=js"

import "./HeroImage.vue?vue&type=style&index=0&id=3dd953ec&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd953ec"]])

export default __exports__